export const mockLandingData = {
  preHero: {
    enabled: true,
    media: 'https://pub-fee310b1ea9c41c1ac58ee2e302a982d.r2.dev/videos/19e9c687-0f2c-4a83-9bfc-4de46a2f154f.mp4'
  },
  hero: {
    headline: 'Gastro Bloggers Day\nПреміум подія, що поєднує гастрономію, блогінг і бренди.\n',
    subheadline: 'Бренди знаходять амбасадорів, блогери — партнерів,\nа гості — нові гастроісторії',
    details: '27.08.2026 • Львів • 200 учасників • тільки офлайн',
    buttons: [
      { text: 'Забронювати квиток', link: 'https://secure.wayforpay.com/payment/gastrobloggersday-lviv', type: 'primary' },
      { text: 'Я блогер — хочу прийти', link: 'https://t.me/nelya_shpilevaya', type: 'secondary' },
      { text: 'Хочу стати партнером', link: 'https://t.me/nelya_shpilevaya', type: 'secondary' },
      { text: 'Хочу стати спікером', link: 'https://t.me/nelya_shpilevaya', type: 'secondary' },
      { text: 'Я представник ЗМІ', link: 'https://t.me/nelya_shpilevaya', type: 'secondary' },
      { text: 'Хочу допомогти як волонтер', link: 'https://t.me/nelya_shpilevaya', type: 'secondary' }
    ]
  },
  sectionTitles: {
    forWhom: 'ДЛЯ КОГО',
    whyCool: 'ЧОМУ ВАМ СПОДОБАЄТЬСЯ',
    eventFormat: 'ФОРМАТ ПОДІЇ',
    personalBrand: 'ПРО ОСОБИСТИЙ БРЕНД',
    gallery: 'ЯК ЦЕ БУЛО',
    testimonials: 'ВІДГУКИ',
    tickets: 'КВИТКИ',
    partners: 'ПАРТНЕРИ',
    organizers: 'ОРГАНІЗАТОРКА'
  },
  forWhom: [
    { title: 'Інфлюенсери', description: 'Контент, колаборації', emoji: '📸' },
    { title: 'Підприємці, HoReCa', description: 'Партнери, PR', emoji: '🏢' },
    { title: 'Food & beverage', description: 'Презентація продукту', emoji: '🍽️' },
    { title: 'Маркетологи, PR', description: 'Контакти', emoji: '📊' },
    { title: 'Особистий бренд', description: 'Знайомства, натхнення', emoji: '✨' }
  ],
  whyCool: [
    { text: 'атмосфера', emoji: '🎭' },
    { text: 'практичний нетворкінг', emoji: '🤝' },
    { text: 'панель інфлюенсерів', emoji: '🎤' },
    { text: 'майстер-класи', emoji: '👨‍🍳' },
    { text: 'дегустації', emoji: '🍷' },
    { text: 'подарунки', emoji: '🎁' },
    { text: 'емоції', emoji: '❤️' }
  ],
  eventFormat: [
    { text: 'Welcome drink', emoji: '🥂' },
    { text: 'Нетворкінг', emoji: '🤝' },
    { text: 'Панель інфлюенсерів', emoji: '🎤' },
    { text: 'Майстер-класи', emoji: '👨‍🍳' },
    { text: 'Кулінарні шоу', emoji: '🔥' },
    { text: 'Фотозона', emoji: '📸' },
    { text: 'Фуршет', emoji: '🍽️' },
    { text: 'Експо-партнери', emoji: '🏆' }
  ],
  personalBrand: {
    title: 'ПРО ОСОБИСТИЙ БРЕНД',
    emoji: '💎',
    items: [
      { text: 'Спікер про особистий бренд', emoji: '🎯' },
      { text: 'Панель інфлюенсерів', emoji: '👥' },
      { text: 'Історії росту', emoji: '📈' },
      { text: 'Як почати', emoji: '🚀' }
    ]
  },
  gallery: [],
  video: {
    title: 'Як пройшла подія',
    url: '',
    type: 'video'
  },
  testimonials: [],
  tickets: [
    {
      id: 1,
      name: 'Early Bird',
      price: 1800,
      originalPrice: 3000,
      showOriginalPrice: true,
      label: 'Лише 30 квитків',
      counter: { current: 27, total: 30 },
      description: '',
      buttonText: 'Купити квиток',
      buttonLink: 'https://secure.wayforpay.com/payment/gastrobloggersday-lviv',
      available: true
    },
    {
      id: 2,
      name: 'Next stage',
      price: 2500,
      originalPrice: null,
      showOriginalPrice: false,
      description: '',
      buttonText: 'Купити квиток',
      buttonLink: 'https://secure.wayforpay.com/payment/gastrobloggersday-lviv',
      available: true
    },
    {
      id: 3,
      name: 'Last Call',
      price: 3000,
      originalPrice: null,
      showOriginalPrice: false,
      note: 'від 20.03',
      description: '',
      buttonText: 'Купити квиток',
      buttonLink: 'https://secure.wayforpay.com/payment/gastrobloggersday-lviv',
      available: false
    }
  ],
  partners: {
    title: 'ПАРТНЕРИ',
    features: ['логотип', 'виступ', 'стенд', 'бренд-зона', 'колаборації', 'активності'],
    buttons: [
      { text: 'Хочу стати партнером', link: 'https://t.me/nelya_shpilevaya' },
      { text: 'Хочу стати спікером', link: 'https://t.me/nelya_shpilevaya' },
      { text: 'Я представник ЗМІ', link: 'https://t.me/nelya_shpilevaya' }
    ]
  }
};
